import React from 'react';

import styles from './CompetitiveAdvantages.module.scss';

const CompetitiveAdvantages = () => {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>
        Điều gì khiến PipFarm trở nên khác biệt và giúp nó cạnh tranh với các quỹ khác?
      </h2>
      <p className={styles.intro}>PipFarm nổi bật vì một số lý do:</p>
      <div className={styles.cardsContainer}>
        <div className={styles.card}>
          <p>
          Chúng tôi tự hào cung cấp nền tảng cTrader, được thiết kế để phát huy tối đa tiềm năng của các nhà giao dịch. cTrader giúp các nhà giao dịch phân tích thị trường kỹ lưỡng, vào lệnh chính xác và quản lý hiệu quả.
          </p>
        </div>
        <div className={styles.card}>
          <p>
          PipFarm là quỹ đầu tiên và duy nhất cung cấp chương trình trung thành dựa trên kinh nghiệm, cho phép người dùng mở khóa các tính năng mới như tỷ lệ chia lợi nhuận cao hơn, đòn bẩy lớn hơn, hoa hồng thấp hơn, giảm giá, thử thách miễn phí và nhiều tính năng khác!
          </p>
        </div>
        <div className={styles.card}>
          <p>
          Chúng tôi đã tạo ra nhiều tính năng độc đáo để giúp các nhà giao dịch quản lý rủi ro. Ví dụ, bảng điều khiển quản lý rủi ro của chúng tôi cung cấp tính năng &quot;kill switch&quot; để đóng tất cả các vị thế khi tài khoản đạt đến mức lợi nhuận hoặc giới hạn mà nhà giao dịch đã đặt.
          </p>
        </div>
        <div className={styles.card}>
          <p>
          PipFarm còn có chương trình bảo vệ thanh toán giúp nhà giao dịch giữ phần lợi nhuận nếu tài khoản cấp vốn của họ bị vi phạm khi đang có lãi. Các công ty khác thường yêu cầu bạn từ bỏ phần lợi nhuận trong trường hợp này. Một điểm khác khiến PipFarm nổi bật là chúng tôi có thể thanh toán cho nhà giao dịch qua nhiều phương thức, trong khi các công ty khác chỉ cung cấp một phương thức.
          </p>
        </div>
      </div>
      <p className={styles.note}>
      Những tính năng này cho thấy chúng tôi thực sự quan tâm đến trải nghiệm của nhà giao dịch, đảm bảo họ có công cụ để quản lý rủi ro và thưởng cho các nhà giao dịch có lợi nhuận nhất quán.
      </p>
    </div>
  );
};

export default CompetitiveAdvantages;
